<template>
  <div>
    <v-container fluid style="background-color: #EEE;">
      <component @goToResum="fCargarPaginaResumen" @goToAsistente="fCargaPaginaAsistente" @loading="fLoading"
        @goToListado="fCargaPaginaListado" @alert="fAlert" :is="pagina" :presupuesto="presupuesto" :origen="origen"
        :pLimitDate="dLimitDate">
      </component>
    </v-container>
  </div>
</template>

<script>

import ShpListado from '@/components/Informes/Presupuestos/ShpListado'
import ShpAsistente from '@/components/Informes/Presupuestos/ShpAsistente'
import ShpResumen from '@/components/Informes/Presupuestos/ShpResumen'

// SERVICIOS
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'ShpInitPresupuesto',
  components: {
    ShpListado,
    ShpAsistente,
    ShpResumen
  },
  props: {
    pLimitDate: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      usuario: '',
      title: this.$t('presupuestosPedidos'),
      mostrarAlertaDesconexion: false,
      pagina: ShpListado,
      presupuesto: null,
      origen: '',
      mostrarAvisos: false,
      textAviso: '',
      menu: false,
      empresaSeleccionada: '',
      itemsEmpresa: [],
      dLimitDate: {}
    }
  },
  beforeDestroy() {
    localStorage.removeItem('empresaPres')
  },
  created() {
    // carga la tipologia de presupuesto
    this.fCargaTipologiaPresupuesto()
    this.dLimitDate = this.pLimitDate
  },
  methods: {
    // CARGAR PAG RESUMEN
    fCargarPaginaResumen(presupuesto, origen) {
      this.origen = origen
      this.presupuesto = presupuesto
      this.pagina = ShpResumen
    },
    // CARGAR PAG ASISTENTE
    fCargaPaginaAsistente(presupuesto, origen) {
      this.origen = origen
      this.presupuesto = presupuesto
      this.pagina = ShpAsistente
    },
    // CARGAR PAG LISTADO
    fCargaPaginaListado() {
      this.pagina = ShpListado
    },
    // EMIT DE LAS ALERTAS
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    // EMIT DE CARGA
    fLoading(msg) {
      this.$emit('loading', msg)
    },
    // CARGA DE LAS TIPOLOGIAS
    fCargaTipologiaPresupuesto() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa
      }
      SrvPres.getTipologiaPres(payload).then(response => {
        if (response.data.statusCode === '200') {
          const datosAutenticacion = this.$store.getters.getAutenticacion
          datosAutenticacion.tipoPresupuesto = response.data.result[0].tipologia
          // Establecemos el token para las siguientes llamadas con axios.
          localStorage.setItem('datos-autenticacion', JSON.stringify(datosAutenticacion))
        } else {
          this.$emit('alert', '<b>carga tipo presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    }
  }
}
</script>
<style scoped>
.jv-link {
  text-decoration: none;
  color: #666;
  margin-left: 15px;
}

.radioButton .accent--text {
  color: #43a047 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpInitPresupuestos.vue